import * as React from 'react';
import { getMediaUrlByContext } from '@wix/editor-elements-library/src/components/ImageX/viewer/ImageX.utils';

export const useVideoPlaybackState = (
  videoRef: React.RefObject<HTMLVideoElement | null>,
) => {
  const [isPlaying, setIsPlaying] = React.useState(false);

  React.useEffect(() => {
    const video = videoRef?.current;
    if (!video) {
      return;
    }

    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);
    const handleEnded = () => setIsPlaying(false);

    video.addEventListener('play', handlePlay);
    video.addEventListener('pause', handlePause);
    video.addEventListener('ended', handleEnded);

    return () => {
      video.removeEventListener('play', handlePlay);
      video.removeEventListener('pause', handlePause);
      video.removeEventListener('ended', handleEnded);
    };
  }, [videoRef]);

  const togglePlayPause = React.useCallback(() => {
    const video = videoRef?.current;
    if (!video) {
      return;
    }
    if (isPlaying) {
      video.pause();
    } else {
      video.play().catch(() => {
        setIsPlaying(false);
      });
    }
  }, [isPlaying, videoRef]);

  return { isPlaying, togglePlayPause };
};

export const getBackgroundImageStyle = (uri?: string) => {
  if (!uri) {
    return {};
  }
  const computedUri = getMediaUrlByContext(uri);
  return { backgroundImage: `url("${computedUri}")` };
};
